import { useRef } from 'react'
import { Outlet } from 'react-router-dom'

import { AppSidebar } from '~/components/app-sidebar'
import { ImpersonationBanner } from '~/components/ImpersonationBanner/ImpersonationBanner'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '~/components/ui/sidebar'
import { useFloatingStatusContext } from '~/contexts/floating-status.context'
import { HeaderActionsProvider } from '~/contexts/HeaderActionsContext'
import { cn } from '~/lib/utils'

type LayoutProps = {
  showHeader?: boolean
  contentClassName?: string
}

export const Layout = ({ showHeader = true, contentClassName = 'pt-2 pb-20' }: LayoutProps) => {
  const headerContainerRef = useRef<HTMLDivElement>(null)
  const { divContainerRef: floatingStatusContainerRef } = useFloatingStatusContext()

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <ImpersonationBanner />
        <HeaderActionsProvider headerContainerRef={headerContainerRef}>
          {showHeader && (
            <header className='sticky top-0 z-50 bg-white border-b px-4 h-16 flex items-center gap-2'>
              <SidebarTrigger />
              <div ref={headerContainerRef} className='flex-1' />
            </header>
          )}
          <div className={cn('w-full flex-1 min-h-0 min-w-0 px-4', contentClassName)}>
            <Outlet />
          </div>
          <div className='fixed bottom-3 right-3'>
            <div ref={floatingStatusContainerRef} />
          </div>
        </HeaderActionsProvider>
      </SidebarInset>
    </SidebarProvider>
  )
}
